@if (isLoading) {
  <div class="loader-overlay">
    <div class="loader-container">
      <img src="assets/images/loader.gif" alt="Loading..." class="loader-image" />
    </div>
  </div>
}

